import {ScheduleState} from "@/lib/types/checks.ts";

export const ON_CALL_STATE_TITLE: Record<ScheduleState, string> = {
  [ScheduleState.ACTIVE]: "Always on call",
  [ScheduleState.SUPPRESSED]: "",
  [ScheduleState.SCHEDULED]: "Use on-call schedule",
};

export const OFFSET_KEY = "offset";
export const LIMIT_KEY = "limit";
